const HOST_URL = "https://api.thundersocialbookmarking.com/";

const VERSION = "v1.0";
const VERSION_1 = 'v1.1';
export const config = {
  BASE_HOST_URL: `${HOST_URL}`,
  ROOT_URL: `${HOST_URL}api/${VERSION}/`,
  ROOT_URL_Version_1: `${HOST_URL}api/${VERSION_1}/`,
  REST_API: {
    Account: {
      LogIn: "Account/Login",
      Register: "Account/Register",
      ForgotPassword: "Account/ForgotPassword",
      ChangePassword: "Account/ChangePassword",
      LogOff: "Account/Logout",
      RefreshToken: "Account/RefreshToken",
      ConfirmUser: "Account/ConfirmUser?userId=",
      ContactUs: "Account/ContactUs",
    },
    UserBookmarks: {
      Get: "UserBookmarks/Get",
      Post: "UserBookmarks/Post",
      GetSpecificBookmark: "UserBookmarks/GetSpecificBookmark",
      GetUserAllBookmarks: "UserBookmarks/GetUserAllBookmarks",
    },
    Categories: {
      Get: "Category/Get",
    },
    LikedBookmarks: {
      GetTopTenLikesBookmark: "UserLikedBookmarks/GetTopTenLikesBookmark",
      LikeUp: "UserLikedBookmarks/LikeUp",
    },
    RegisterBookmarks: {
      GetActiveBookmarkSites: "RegisterBookmarks/GetActiveBookmarkSites",
    },
  },
};
